import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { TranslatorProvider } from './components/translator/provider'
import '@/styles/global.css'
import { ErrorBoundary } from './components/errorBoundary'
import { App } from './App'
import { initializeSentry } from './config/sentry'

initializeSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary linkTo="タウン">
      <TranslatorProvider>
        <App />
      </TranslatorProvider>
    </ErrorBoundary>
  </StrictMode>,
)
